export default {
    //代理用户
    agency_key: '',
    mode:'',
    //用户中心的域名
    uc_host: 'https://user.ruanwen.la',
    indexHost: 'https://www.ruanwen.la',
    //专题页的域名
    special_url: '/',
    site_title: '软文街—一站式智能广告营销平台',
    welcome_title: '软文街—一站式智能广告营销平台！',
    site_short_title: '软文街',
    site_subtitle: '一站式智能广告营销平台',
    beian: '沪ICP备13026404号-2',
    beian_gn: '',
    company_name: '上海亿哲网络科技有限公司',
    copyright: '版权所有：上海亿哲网络科技有限公司 Copyright ©2013-2024 All Right Reserved',
    logo: 'https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/images/logo.svg',
    favicon:'/static/favicon.ico',
    agreement_signup:'https://www.ruanwen.la/agreement/',
    chat_url:'https://tb.53kf.com/code/client/4fc71c35adbd778bae3a4e749e0b4c898/3',
    payment:'',
    qq: '2885262578',
    tel: '4008-520-553'
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 